import { ValueFormatterParams } from "ag-grid-community";
import React, { Fragment, useCallback, useRef, useState } from 'react';
import { ColumnDef } from "../../../../components/Grid/model/Grid.ts";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import IdentifyVehicleIcon from "../../../../assets/images/identifyVehicleIcon.svg";
import { useModal } from "../../../../hooks/ModalContext.tsx";
import { formatDateBR, formatDateTimeBR, getActiveTypes, maskCnpj } from "../../../../helpers/format.ts";
import { ITransportadoras } from "./types/types.ts";
import TransportadorasVeiculos from './components/TransportadoraVeiculos/index.tsx';
import ModalDelete from "../../../../components/ModalDelete";
import Info from "./Info";
import api from "../../../../services/api.ts";
import Loading from "../../../../core/common/Loading";
import Create from './Create';
import ModalHistory from "../../../../components/ModalHistory";
import ExportModal from "./ExportModal";
import ExportIcon from "../../../../assets/images/exportIcon.svg";
import Can from "../../../../components/Can";

const Transportadoras: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "cnpj",
      headerName: "CNPJ",
      filter: true,
      valueFormatter: (params) => {
        if(params.value) {
          return maskCnpj(params.value)
        }

        return '---';
      }
    },
    {
      field: "razao_social",
      headerName: "Razão Social",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "nome_fantasia",
      headerName: "Nome Fantasia",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "faturamento_triagem",
      headerName: "Faturamento Triagem",
      filter: true,
      type: "booleanColumn",
      filterParams: {
        selected: {
          isMultiple: false,
          data: getActiveTypes(),
        },
      },
      valueFormatter: (params) => {
        if (params.value) {
          return "SIM";
        }
        return "NÃO";
      }
    },
    {
      field: "faturamento_estadia",
      headerName: "Faturamento Estadia",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return "SIM";
        }
        return "NÃO";
      }
    },
    {
      field: "rntrc",
      headerName: "RNTRC",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "data_expiracao_rntrc",
      headerName: "Data Expiração RNTRC",
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      valueFormatter: (params) => {
        if (params.value) {
          return formatDateBR(params.value);
        }
        return "---";
      }
    },
    {
      field: "endereco",
      headerName: "Endereço",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "complemento",
      headerName: "Complemento",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "numero",
      headerName: "Número",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "bairro",
      headerName: "Bairro",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "cidade",
      headerName: "Cidade",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "uf_estado",
      headerName: "Estado",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "cep",
      headerName: "CEP",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data de Modificação",
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      valueFormatter: (params) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "----";
      },
    }
  ]);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [showTransportadorasVeiculos, setShowTransportadorasVeiculos] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState<boolean>(false);

  const [selectedRow, setSelectedRow] = useState<ITransportadoras>();

  const { openModal, isModalOpen, closeModal } = useModal();
  const gridRef = useRef<any>(null);

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);

      const body = {
        id_transportadora: rowId,
      };

      await api.post("/deletar/transportadoras", body);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, [])

  console.log(isModalOpen);

  return (
    <Fragment>
      <Loading loading={loading} />

      {isModalOpen && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}
      {showTransportadorasVeiculos && (
        <TransportadorasVeiculos
          selectedRow={selectedRow}
          onClear={() => {
            setShowTransportadorasVeiculos(false);
            setIsEdit(false);
          }}
          onConfirm={() => {
            setShowTransportadorasVeiculos(false);
            setIsEdit(false);
          }}
        />
      )}
      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_transportadora)}
          row={selectedRow?.razao_social}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Transportadoras"
          onClose={() => setIsView(!isView)}
        />
      )}

      {isHistory && selectedRow && (
        <ModalHistory
          isOpen={isHistory}
          title="Histórico - Transportadoras"
          historyRoute="/historico/transportadoras"
          bodyKey="id_transportadora"
          bodyValue={selectedRow.id_transportadora}
          onClose={() => setIsHistory(false)}
        />
      )}
      <ExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        currentFilters={gridRef.current?.getFilters() || {}}
      />

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Transportadoras</h1>
          </div>
          <div className="mr-14 flex items-center gap-4">
            <Can acao="EXPORTAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full gap-2 hover:bg-[#0a3d6a] transition-colors"
              onClick={() => setIsExportModalOpen(true)}
              id="btnExport"
            >
              Exportar
              <img src={ExportIcon} alt="" className="w-4 h-4 invert" />
            </button>
            </Can>
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => openModal()}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/transportadoras"
            onDelete={(data: ITransportadoras) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            status={[]}
            onView={(data: ITransportadoras) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onUpdate={(data: ITransportadoras) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              openModal();
            }}
            onHistory={(data: ITransportadoras) => {
              setSelectedRow(data);
              setIsHistory(true);
            }}
            customButtons={[
              {
                label: "Veiculos da Transportadora",
                action: (data: ITransportadoras) => {
                  setSelectedRow(data);
                  setShowTransportadorasVeiculos(true);
                },
                status: [],
                icon: () => {
                  return IdentifyVehicleIcon;
                },
              },
            ]}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default Transportadoras;
